<template>
  <PageHeader :pageTitle="pageTitle" :pageSubtitle="pageSubtitle" />
  <div class="container mb-5 mt-5">
    <div v-html="html" class="wysiwyg"></div>
    <PageControls
      :nextSection="nextSection"
      :prevSection="prevSection"
      :nextTest="nextTest"
      :testText="testText"
    />
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import PageControls from "@/components/PageControls.vue";
import axios from "@/http";
import { useStore } from "vuex";
import { ref } from "@vue/reactivity";
import { computed, onMounted, onUpdated } from "@vue/runtime-core";
import usePretendFetchData from "@/composables/usePretendFetchData";

export default {
  props: ["id"],
  components: { PageHeader, PageControls },
  setup(props) {
    const store = useStore();
    const html = ref(null);
    const pageTitle = ref(null);
    const pageSubtitle = ref(null);
    const prevSection = ref(false);
    const nextSection = ref(false);
    const nextTest = ref(false);
    const testText = ref(null);

    const user = computed(() => store.state.user);

    const setData = (data) => {
      pageTitle.value = data.module.name;
      html.value = data.body;
      prevSection.value = data.prev_section;
      nextSection.value = data.next_section;
      nextTest.value = data.next_test;
      testText.value = data.module.test_text;

      document.title = `${data.module.name} - ძირითადი საკითხები თანასწორობის უფლების შესახებ`;

      if (!data.hide_title) {
        pageSubtitle.value = data.title;
      } else {
        pageSubtitle.value = null;
      }
    };

    onUpdated(() => {
      store.commit(
        "setStep",
        JSON.stringify({
          user: user.value.id,
          page: props.id,
        })
      );

      document.activeElement.blur();
    });

    // onMounted(async () => {
    //   const res = await axios.post(
    //     "getSection",
    //     { id: props.id },
    //     { headers: { Authorization: `Bearer ${store.state.token}` } }
    //   );

    //   pageTitle.value = res.data.data.module.name;
    //   html.value = res.data.data.body;

    //   prevSection.value = res.data.data.prev_section;
    //   nextSection.value = res.data.data.next_section;
    //   nextTest.value = res.data.data.next_test;

    //   store.commit("setStep", props.id);

    //   console.log("onmounted");

    //   document.title = `${res.data.data.module.name} - ძირითადი საკითხები თანასწორობის უფლების შესახებ`;

    //   if (!res.data.data.hide_title) {
    //     pageSubtitle.value = res.data.data.title;
    //   }
    // });

    return {
      html,
      pageTitle,
      pageSubtitle,
      prevSection,
      nextSection,
      nextTest,
      setData,
      testText
    };
  },
  beforeRouteEnter(to, from, next) {
    usePretendFetchData("getSection", to.params.id, (data) => {
      next((vm) => vm.setData(data));
    });
  },
  beforeRouteUpdate(to, from, next) {
    usePretendFetchData("getSection", to.params.id, (data) => {
      this.setData(data);
      next();
    });
  },
};
</script>

<style>
</style>